module.exports = __webpack_public_path__ + "static/media/vehicle12.fcd47932.svg";